export { default as Img200 } from './processed/200/The-Hills-Banner.jpg';
export { default as Img400 } from './processed/400/The-Hills-Banner.jpg';
export { default as Imgthumb } from './processed/thumb/The-Hills-Banner.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/The-Hills-Banner.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/The-Hills-Banner.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      53,
      114,
      204
    ],
    "_population": 4274,
    "_hsl": [
      0.5993377483443708,
      0.5968379446640317,
      0.503921568627451
    ]
  },
  "LightVibrant": {
    "_rgb": [
      154,
      188,
      228
    ],
    "_population": 11,
    "_hsl": [
      0.5900900900900901,
      0.578125,
      0.7490196078431373
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      28,
      36,
      124
    ],
    "_population": 1,
    "_hsl": [
      0.6527777777777778,
      0.631578947368421,
      0.2980392156862745
    ]
  },
  "Muted": {
    "_rgb": [
      172,
      76,
      76
    ],
    "_population": 1,
    "_hsl": [
      0,
      0.3870967741935484,
      0.4862745098039216
    ]
  },
  "LightMuted": {
    "_rgb": [
      220,
      204,
      188
    ],
    "_population": 2,
    "_hsl": [
      0.08333333333333333,
      0.3137254901960785,
      0.8
    ]
  },
  "DarkMuted": {
    "_rgb": [
      116,
      68,
      56
    ],
    "_population": 161,
    "_hsl": [
      0.03333333333333333,
      0.34883720930232553,
      0.33725490196078434
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/The-Hills-Banner.js